<template>
  <div v-if="orderCompleted">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="alert alert-success d-flex" role="alert">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z"/>
            </svg>
          </div>
          <div>
            <h2>{{ __('Thank you') }}</h2>
            <h4>{{ __('Your order was accepted') }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div v-if="fetchingData || capturingPayment" class="d-flex justify-content-center py-5 my-3">
      <div class="spinner-border text-secondary" style="width: 60px; height: 60px; border-width: 8px;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-else-if="requestFailed">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="alert alert-danger p-4">
            <h4 class="alert-heading">Whoops, error has occurred</h4>
            <p class="mb-0">Please try again later</p>
          </div>
        </div>
      </div>
    </div>

    <template v-else>
      <Cart/>
      <ContactInformations v-if="type === 'form'" @order-completed="orderCompleted = true"/>
    </template>
  </div>
</template>

<script>
import ApplyConfig from "@/mixins/ApplyConfig";
import Api from "@/Services/Api";
import ContactInformations from "@/components/ContactInformations";
import Cart from "@/components/Cart";
import LocalStorage from "@/Services/LocalStorage";
import LocationUrl from "@/Services/LocationUrl";
import PayPal from "@/Services/Payment/PayPal";
import TrustPay from "@/Services/Payment/TrustPay";

export default {
  name: 'ShopOrderForm',

  components: {Cart, ContactInformations},

  mixins: [ApplyConfig],

  data() {
    return {
      fetchingData: false,
      capturingPayment: false,
      requestFailed: false,
      orderCompleted: false,
    };
  },

  computed: {
    type() {
      return this.$store.state.type;
    },
  },

  mounted() {
    if (LocationUrl.isOrderCompleted()) {
      if (PayPal.isPayPalOrder()) {
        this.capturingPayment = true;

        PayPal.capturePayment()
          .then(() => this.orderCompleted = true)
          .catch(() => this.requestFailed = true)
          .finally(() => this.capturingPayment = false);
      } else if (TrustPay.isTrustPayOrder()) {
        this.orderCompleted = true;
      }
    }

    this.applyConfig();

    this.fetchWebsiteProducts()
      .then(() => {
        LocationUrl.applyUrlQueryParams();
        LocalStorage.loadDataFromLocalStorage();
        LocalStorage.setupStoreWatchers();
      });
  },

  methods: {
    fetchWebsiteProducts() {
      this.fetchingData = true;

      return Api.getWebsiteProducts()
        .then(resp => {
          this.$store.state.currency        = resp.data.currency;
          this.$store.state.products        = resp.data.products.map(p => ({...p, quantity: 0}));
          this.$store.state.shippingOptions = resp.data.shipping_options;
          this.$store.state.translations    = resp.data.translations;
        })
        .catch(() => this.requestFailed = true)
        .finally(() => this.fetchingData = false);
    },
  },
}
</script>
